module.exports = __webpack_public_path__ + "static/media/v21.a5105b74.mp4";